import type { Residence } from '@repo/sdk/gen'
import { makeBreadcrumbFromCache } from '@repo/ui/components/query-breadcrumbs'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import i18n from '@/lib/i18n'
import { makeQueryKeys } from '@/query/query-keys'
import { CallStateBadge } from '@/routes/(private)/-components/call-state-badge'
import { ResidenceDetailPage } from './-components/residence-detail-page'
import { RESIDENCE_TABS } from './-components/residence-tabs'

const searchSchema = z.object({
	tab: z.enum(RESIDENCE_TABS).optional().catch(undefined)
})

export const Route = createFileRoute('/(private)/residences/$residenceId/')({
	validateSearch: searchSchema,
	staticData: {
		breadcrumb: ({ params, queryClient }) =>
			makeBreadcrumbFromCache<Residence | null>(
				queryClient,
				makeQueryKeys.residences.detail(params.residenceId),
				(residence) =>
					residence?.name ??
					i18n.t('admin-residences:detail.breadcrumb'),
				(residence) =>
					residence && <CallStateBadge state={residence.call.state} />
			)
	},
	component: ResidenceDetailPage
})
